import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDateOnlyPipe',
})
export class FormatDateOnlyPipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): any {
    if (value) {
      return new DatePipe('en-GB').transform(value, 'dd/MM/yyyy');
    }
    return value;
  }
}
